import { DOCS_URL } from "../../../config/constants.js";
import uploadToMuxCardGridiItem from "../../../utils/uploadToMuxCardGridiItem.js";
import CardGridItem from "./CardGridItem.svelte";

export default {
    component: CardGridItem,
    name: "Card Grid - Card",
    description: "Child of Card Grid",
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/square.svg",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-cardgriditem--docs`,
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2F3c4e58adcd6a4c2d98d054f119d9953e",
    inputs: [
        {
            friendlyName: "Title",
            name: "title",
            type: "text",
        },
        {
            friendlyName: "Description",
            name: "description",
            type: "longText",
        },
        {
            friendlyName: "Link",
            name: "to",
            type: "text",
        },
        {
            friendlyName: "Image",
            name: "image",
            type: "object",
            helperText: "16:9 Aspect Ratio",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpeg", "jpg", "webm", "gif", "png", "svg"],
                    defaultValue: "https://placehold.co/400",
                },
                {
                    friendlyName: "Alt",
                    name: "alt",
                    type: "text",
                },
            ],
        },
        {
            friendlyName: "Video",
            name: "videoUrl",
            type: "file",
            allowedFileTypes: ["mov", "webm", "mp4"],
            helperText: "Recommended 16:9 to match the card thumbnail frame.",
            onChange: uploadToMuxCardGridiItem,
        },
        {
            friendlyName: "Mux Video ID",
            name: "muxId",
            hidden: true,
            type: "text",
            helperText: "Recommended 16:9 to match the card thumbnail frame.",
        },
    ],
    requiresParent: {
        message: "You can only use this as a child of a Card Grid component",
        component: "Card Grid",
    },
};
